export type MetaCustomer = { em?: string; ph?: string; fn?: string; ln?: string; ct?: string };

export async function hashMetaCustomer(customer: MetaCustomer): Promise<Record<string, string>> {
  const result: Record<string, string> = {};
  for (const [key, raw] of Object.entries(customer)) {
    let value = (raw ?? '').replace(/\s+/gu, '').toLowerCase();
    if (key === 'ph') {
      value = value.replace(/\D/g, '');
      if (value.length === 9) value = `995${value}`;
    }
    if (!value) continue;
    const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
    result[key] = Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, '0')).join('');
  }
  return result;
}

export function metaCookies(): { fbp?: string; fbc?: string } {
  const cookies = Object.fromEntries((document.cookie ?? '').split(';').map((cookie) => {
    const [key, ...value] = cookie.trim().split('=');
    return [key, value.join('=')];
  }));
  return {
    ...(cookies['_fbp'] ? { fbp: cookies['_fbp'] } : {}),
    ...(cookies['_fbc'] ? { fbc: cookies['_fbc'] } : {}),
  };
}
